module.exports = {"street_name":"Straße","select_street":"Wählen Sie unten die Straße aus","enter_street_name":"Gib die Straße ein","search_street_name":"Suche nach Straßennamen"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/i18next/de/street.json
// module id = 501
// module chunks = 248 1661